const getBrand = (): Brand =>
  window.commonConfig?.brand
    ? window.commonConfig.brand
    : location.host.endsWith('editorx.com')
    ? 'editorx'
    : 'wix';

export const getPromoteFramePath = (): string =>
  `https://www.${getBrand()}.com/vmpromotehome/videomaker`;

export const getPromoteSubFramePath = (): {
  promoteSubFrameSrc: string;
  promoteSubFrameNew: string;
} => ({
  promoteSubFrameSrc: `https://www-${getBrand()}-com.filesusr.com`,
  promoteSubFrameNew: `https://www-${getBrand()}-com.usrfiles.com`,
});
